export default {
  browse:{
    table:{
      headers: [
        {
          text: 'No.',
          value: 'index',
          sortable: false,
          filterable: false,
        },
        {
          text: 'Key',
          value: 'key',
        },
        {
          text: 'Name',
          value: 'translatableName',
        },
      ],
    },
  },
  read:false,
  add:false,
  edit:false,
  delete:false,
}